import { DiscountGroup, ProductGroupCount } from '@retail/products/types';
import { CentralAssortmentFilterContextDTO, HierarchyFilterContextDTO } from '../dto';
import { SupplierBase } from '@retail/suppliers/types';
import { AssortmentTag } from './AssortmentTag';

interface FilterContextProps {
  suppliers?: SupplierBase[];
  productGroups: ProductGroupCount[];
  discountGroupsForSupplier?: DiscountGroup[];
  assortmentTags?: AssortmentTag[];
}

export class HierarchyFilterContext {
  suppliers?: SupplierBase[];
  productGroups: ProductGroupCount[];
  discountGroupsForSupplier?: DiscountGroup[];
  assortmentTags?: AssortmentTag[];

  constructor({
    suppliers,
    productGroups,
    discountGroupsForSupplier,
    assortmentTags,
  }: FilterContextProps) {
    this.suppliers = suppliers;
    this.productGroups = productGroups;
    this.discountGroupsForSupplier = discountGroupsForSupplier;
    this.assortmentTags = assortmentTags;
  }

  static fromDto = (dto: HierarchyFilterContextDTO): HierarchyFilterContext =>
    new HierarchyFilterContext({
      suppliers: dto.suppliers?.map(SupplierBase.fromDto) ?? [],
      productGroups: dto.productGroups?.map(ProductGroupCount.fromDto) ?? [],
      discountGroupsForSupplier: dto.discountGroupsForSupplier?.map(DiscountGroup.fromDto) ?? [],
      assortmentTags: dto.assortmentTags?.map(AssortmentTag.fromDTO) ?? [],
    });
}

interface CentralFilterContextProps {
  suppliers: SupplierBase[];
  productGroups: ProductGroupCount[];
  assortmentTags: AssortmentTag[];
}
export class CentralHierarchyFilterContext {
  suppliers: SupplierBase[];
  productGroups: ProductGroupCount[];
  assortmentTags: AssortmentTag[];

  constructor({ suppliers, productGroups, assortmentTags }: CentralFilterContextProps) {
    this.suppliers = suppliers;
    this.productGroups = productGroups;
    this.assortmentTags = assortmentTags;
  }

  static fromDto = (dto: CentralAssortmentFilterContextDTO): CentralHierarchyFilterContext =>
    new CentralHierarchyFilterContext({
      suppliers: dto.suppliers?.map(SupplierBase.fromDto) ?? [],
      productGroups: dto.productGroups?.map(ProductGroupCount.fromDto) ?? [],
      assortmentTags: dto.assortmentTags?.map(AssortmentTag.fromDTO) ?? [],
    });
}
